import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { RegisterMode } from '@app/dev/actions/terminal';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';

import './style.scss';

// rename this component just success popup

const RegisterSuccess = ({ title, subTitle }) => {
  const [{ closePopup }] = useContext(PopupContext);
  const dispatch = useDispatch();
  const t = useTranslation();

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">
        {t(title)}
        !
      </h3>
      <div className="popup-main-content">
        <i className="global-icon icon-circle-done done-icon" />
        <p className="text-center">{t(subTitle)}</p>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={() => {
            closePopup();
            dispatch(RegisterMode(false)); // move this to right place and make component fully common
          }}
          className="popup-cancel-button rfid-cancle"
        >
          {t('Cancel')}
        </button>
      </div>
    </div>
  );
};

RegisterSuccess.defaultProps = {
  title: 'Congratulations',
  subTitle: 'Your registration was successful',
};

RegisterSuccess.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default RegisterSuccess;
